import {useHistory} from "react-router";
import {useConfirm} from "material-ui-confirm";
import React, {useCallback} from "react";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";

export default function BackButton({confirmOnRedirect, redirectOnConfirm}) {
    const history = useHistory()
    const confirm = useConfirm();
    const handleClick = useCallback(() => {
        const redirect = () => !!redirectOnConfirm ? history.push(redirectOnConfirm) : history.goBack()
        if (!!confirmOnRedirect) {
            confirm({
                title: 'Unsaved Changes!',
                confirmationText: 'Continue',
                cancellationText: 'Stay On Page',
                description: 'There are unsaved changes on your page. Are you sure you want to continue?'
            }).then(() => {
                redirect()
            }).catch(() => console.log('Staying on page...'))
        } else redirect();
    }, [history, confirmOnRedirect, redirectOnConfirm, confirm])
    return <Button onClick={() => handleClick()} size="large" variant="contained" color="secondary" data-cy="back-button">
        Back
    </Button>
}
BackButton.propTypes = {
    confirmOnRedirect: PropTypes.bool,
    redirectOnConfirm: PropTypes.string
}
